import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { ClientsBanner } from '../../components/ClientsBanner'

export default function PersonnalizedLoan() {
    return (
        <div>
            <Seo
                title="Prêt personnalisé en ligne rapide | Trouvez les meilleures offres | Argent Aujourd’hui"
                description="Comparez les prêts personnalisés sur notre site et choisissez l'option idéale pour vos besoins financiers. Accédez aux meilleures offres dès maintenant."
                type="webapp"
                name="Argent Aujourd'hui"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Prêt personnalisé</h1>

                    <p className="header-subtitle">
                        Obtenez un prêt personnalisé de 100 $ à 1500 $ dans les meilleures
                        conditions grâce à Argent Aujourd’hui! Nous comparons pour vous les
                        différentes options de financement pour obtenir un prêt adapté à vos besoins
                        dès aujourd’hui. Une solution confidentielle, gratuite et sécurisée!
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Obtenir un prêt personnalisé en 4 étapes</h2>

                    <div className="steps" style={{ marginTop: 50 }}>
                        <ol>
                            <li>
                                <h3>Remplissez notre formulaire de demande en ligne</h3>
                                <p>
                                    Commencez par{' '}
                                    <Link to="/new-lead">compléter notre formulaire en ligne</Link>{' '}
                                    en nous renseignant vos coordonnées ainsi que le montant que
                                    vous aimeriez obtenir. Sur base de ces informations, nous vous
                                    transmettons une comparaison des offres de nos partenaires en
                                    temps réel avec leurs taux d’intérêt, les montants qu’ils
                                    pourraient vous prêter et leur délai.
                                </p>
                            </li>
                            <li>
                                <h3>Choisissez une institution de financement</h3>
                                <p>
                                    En comparant les différentes offres de nos partenaires, vous
                                    pouvez{' '}
                                    <span className="bold">
                                        choisir le prêt personnalisé qui correspond le mieux à vos
                                        besoins.
                                    </span>{' '}
                                    En cliquant sur l'institution de votre choix, vous serez
                                    automatiquement redirigé vers leur formulaire de contact pour
                                    faire votre demande de prêt immédiat. Une fois la demande
                                    envoyée, vous devriez recevoir une réponse en moins d’une heure.
                                    Prenez note de leurs heures d’ouverture pour connaître le délai
                                    éventuel de réponse.
                                </p>
                            </li>
                            <li>
                                <h3>Faites votre demande</h3>
                                <p>
                                    Chaque prêteur a ses propres critères d’admission. En règle
                                    générale, vous devrez
                                    <span className="bold">
                                        {' '}
                                        fournir une pièce d’identité avec une photo récente
                                    </span>{' '}
                                    (carte d’assurance maladie, permis de conduire ou passeport).
                                    Ensuite, l’institution effectue une vérification bancaire
                                    instantanée (prêt IBV). Cette démarche permet de vérifier votre
                                    capacité de remboursement, sans effectuer d’enquête de crédit.
                                </p>
                            </li>
                            <li>
                                <h3>Obtenez votre prêt dans les 24h</h3>
                                <p>
                                    Une fois que vous avez obtenu votre approbation, vous recevrez
                                    votre paiement{' '}
                                    <span className="bold">
                                        dans les 24 heures suivant la signature de votre contrat.
                                    </span>{' '}
                                    Le virement se fait via Interac à l’adresse que vous avez
                                    fournie. Selon l’institution, si vous effectuez votre demande
                                    dans la matinée, le prêt peut se faire la journée même!
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Choisissez le montant dont vous avez besoin!</h2>

                    <div className="loan-options">
                        <ul>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 100$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 200$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 300$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 500$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 700$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 000$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 500$</li>
                            </Link>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Obtenez un crédit personnalisé grâce à Argent Aujourd’hui
                    </h2>

                    <p className="sect-subtitle">
                        La vie est remplie d'imprévus et personne n’est à l'abri d’une difficulté
                        financière soudaine. Pour obtenir un prêt personnalisé rapide et sans
                        impacter votre dossier de crédit, Argent Aujourd’hui vous fournit une{' '}
                        <b>comparaison d’institutions de financement en ligne</b> fiables et
                        sécuritaires. En quelques clics, trouvez une option de prêt alternatif qui
                        répond à votre situation et obtenez un prêt par virement interac dans les 24
                        heures. Les conditions pour rembourser votre prêt dépendent de chaque
                        institution.
                    </p>

                    <div className="container">
                        <div className="row content">
                            <div className="col-lg-6">
                                <h3>Les avantages de nos produits</h3>
                                <ul className="styled-checklist" style={{ marginTop: 20 }}>
                                    <li>Approbation rapide</li>
                                    <li>Sécuritaire, gratuit et sans engagement</li>
                                    <li>Prêt sans enquête de crédit</li>
                                    <li>Admissible en cas de mauvais crédit</li>
                                    <li>Des partenaires transparents avec des normes élevées </li>
                                </ul>
                            </div>

                            <div className="col-lg-6 pt-4 pt-lg-0">
                                <h3>Des prêts immédiats pour tous les besoins</h3>
                                <p>
                                    Pour vous accompagner dans une situation difficile, Argent
                                    Aujourd’hui compare pour vous les solutions de prêts rapides et
                                    sans enquête de crédit au Québec. Et vous n’avez pas à justifier
                                    la raison de l’emprunt! Quelle que soit votre situation, nous
                                    offrons des solutions personnalisées pour répondre à votre
                                    besoin immédiat d’argent :
                                </p>
                                <ul className="styled-checklist" style={{ marginTop: 20 }}>
                                    <li>Avance de fonds</li>
                                    <li>Prêt d'urgence</li>
                                    <li>Prêt personnel</li>
                                    <li>Prêt sur salaire</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="Eligible sect-bg-light">
                <div className="card" data-aos="fade-up">
                    <div className="content">
                        <div className="section-title">
                            <h2>Êtes-vous éligible?</h2>
                        </div>
                        <p>
                            Pour obtenir un prêt personnalisé avec l’une de nos institutions
                            partenaires, vous devez :
                        </p>
                        <ul>
                            <li>Avoir au moins 18 ans</li>
                            <li>Résider au Québec</li>
                            <li>Avoir un revenu stable</li>
                            <li>Ne pas avoir d’opposition de paiement</li>
                            <li>
                                Avoir le moins de frais de fonds non suffisants possible (frais NSF)
                            </li>
                        </ul>
                        <p>
                            Vous pouvez également obtenir des prêts sans emploi ou des prêts en cas
                            de mauvais crédit.
                        </p>
                        <Link to="/new-lead" className="btn">
                            Demander un prêt
                        </Link>
                    </div>
                </div>
            </section>

            <ClientsBanner />

            <Footer />
        </div>
    )
}
